import { SagaIterator } from 'redux-saga';
import axios from 'axios';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { PapiRequestDaUserProfileStatsMyContent } from '@wix/da-types-papi';
import {
  setMySubmissionsSortBy,
  setMySubmissionsIsLoading,
  setMySubmissionsStats,
} from '../actions/statsSection';
import { getTimePeriod } from '../selectors/statsSection';
import { API_BASE_PATH } from '../../server/routes/constants';

function fetchFromApi(requestUrl, params) {
  return axios
    .get(`${API_BASE_PATH}/${requestUrl}`, { params })
    .catch(response => false);
}

export function* setMySubmissionsSortBySaga(
  action: ReturnType<typeof setMySubmissionsSortBy>
): SagaIterator {
  const { payload: sortBy } = action;
  const timePeriod = yield select(getTimePeriod);

  yield put(setMySubmissionsIsLoading(true));

  const params: PapiRequestDaUserProfileStatsMyContent = {
    time_period: timePeriod,
    sort_by: sortBy,
  };

  const result = yield call(fetchFromApi, '/stats/my_content', params);

  if (result && result.data) {
    yield all([
      put(setMySubmissionsStats(result.data.myContent)),
      put(setMySubmissionsIsLoading(false)),
    ]);
  }
}

export default function* statsSectionSaga() {
  yield all([takeEvery(setMySubmissionsSortBy, setMySubmissionsSortBySaga)]);
}
